<template>
    <div
        :class="[`progress-bar flex relative rounded-3xl w-full`, type === 'rectangle' ? 'h-6 bg-slate-200' : 'h-full']"
    >
        <div
            v-if="value > 0"
            :class="['flex flex-row items-center w-full h-full absolute px-2.5', contentClasses]"
        >
            <span v-if="type === 'rectangle'">{{ t('matching.percentage_text') }}</span>
            <span>{{ displayValue }}%</span>
        </div>
        <div
            :class="type"
            :style="cssVars"
        ></div>
    </div>
</template>

<script>
import { useTranslation } from 'i18next-vue';

export default {
    name: 'Percentage',
    props: {
        value: {
            type: Number,
            default: 100,
        },
        type: {
            type: String,
            default: 'circle',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { t } = useTranslation('career-corner');
        return { t };
    },
    computed: {
        contentClasses() {
            return this.type === 'rectangle' ? 'justify-between' : 'justify-center';
        },
        cssVars() {
            let colorRingActive = '--colors-blue-600';
            if (this.value >= 75) {
                colorRingActive = '--colors-green-500';
            } else if (this.value <= 25) {
                colorRingActive = '--colors-red-600';
            } else {
                colorRingActive = '--colors-blue-600';
            }
            return {
                '--value': this.value,
                '--colors-ring-active': `rgb(var(${colorRingActive}))`,
            };
        },
        displayValue() {
            return Math.round(Number(this.value));
        },
    },
};
</script>

<style lang="scss" scoped>
.progress-bar {
    --colors-inner: rgb(var(--colors-slate-50));
    --colors-ring-inactive: rgb(var(--colors-slate-50));
    width: 100%;
}

.circle {
    border-radius: 50%;
    width: 100%;
    height: 100%;
    background:
        radial-gradient(closest-side, var(--colors-inner) 80%, transparent 80% 100%),
        conic-gradient(var(--colors-ring-active) calc(var(--value) * 1%), var(--colors-ring-inactive) 0);
}

.rectangle {
    @apply rounded-3xl;
    width: calc(var(--value) * 1%);
    background-color: var(--colors-ring-active);
    height: 100%;
}
</style>
